import { FC, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { PaginateModel } from "../../models/PaginateModel";
import * as TaxGroupCRUD from './TaxGroupCRUD';
import { PaginationLength } from "../../../_metronic/partials/pagination/PaginationLength";
import { Paginate } from "../../../_metronic/partials/pagination/Paginate";
import { PaginationHeader } from "../../../_metronic/partials/pagination/PaginationHeader";
import { Link, useHistory } from "react-router-dom";
import { download, Toast } from "../../modules/common/helper";
import queryString from 'query-string'
import TaxGroupTable from "./TaxGroupTable";
import TaxGroupCreateModal from "./TaxGroupCreateModal";
import TaxGroupEditModal from "./TaxGroupEditModal";
import { includes, without, map } from 'lodash';
import { Confirm } from "../../modules/common/helper";
import { UserLoggedIn } from "../../hooks/PermissionChecker";
import { HeaderModel } from "../../models/CommonModel";
import ConfigModal from "./ConfigModal";
import { generateCode } from "../../selectors";
import { DEFAULT_PER_PAGE } from "../../constants/common";
import { ModalModel, MstTaxGroupModel, SearchModel } from "../../models/MstTaxGroupModel";

const TaxGroup: FC = () => {
  const intl = useIntl();
  const history = useHistory();
  const [dataPaginate, setDataPaginate] = useState<PaginateModel<MstTaxGroupModel>>();
  const [arrDelete, setArrDelete] = useState<number[]>([])
  const [hideCols, setHideCols] = useState<string[]>([]);
  const [configModal, setConfigModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });
  const [createModal, setCreateModal] = useState<ModalModel>({
    show: false,
    mode: 'add',
  });

  const [editModal, setEditModal] = useState<ModalModel>({
    show: false,
    mode: 'edit',
  });

  const initSearch = {
    page: 1,
    per_page: DEFAULT_PER_PAGE,
  }
  const [search, setSearch] = useState<SearchModel>(initSearch)

  const parseParams = (params: SearchModel) => {
    if (params.page) {
      params.page = +params.page
    }
    if (params.per_page) {
      params.per_page = +params.per_page
    }
    return params
  }

  useEffect(() => {
		document.title = 'Sento - Thiết lập nhóm ngành sản phẩm';
	})

  useEffect(() => {
    const searchHistory = history.location.search;
    const initParams: SearchModel = parseParams(queryString.parse(searchHistory))
    getData({ ...search, ...initParams });
  }, []);

  const getData = async (params?: SearchModel) => {
    const { data: dataPaginate } = await TaxGroupCRUD.getList(params);
    const objQuery = { ...params }
    if (objQuery.page === 1) {
      delete objQuery.page
    }
    if (objQuery.per_page === DEFAULT_PER_PAGE) {
      delete objQuery.per_page
    }
    history.push({ search: `?${queryString.stringify(objQuery)}` })
    setDataPaginate(dataPaginate);
    setSearch(params ?? {});
  }

  const handleSort = (sortBy: string, direction: 'asc' | 'desc' | 'none') => {
    const currentSearch = { ...search };
    const sortParams: SearchModel = { ...currentSearch, sort_by: sortBy, sort_direction: direction };
    if (direction === 'none') {
      delete sortParams.sort_by;
      delete sortParams.sort_direction;
    }
    getData({ ...sortParams });
  }

  const handlePageChange = (data: any) => {
    getData({ ...search, page: data.selected + 1 })
  }

  const handlePageLengthChange = (e: any) => {
    getData({ ...search, page: 1, per_page: +e.target.value })
  }

  const handleEdit = (item: MstTaxGroupModel) => {
    setEditModal({
      show: true,
      mode: 'edit',
      data: item
    });
  }

  const handleSubmit = async (values: any, actions: any) => {
    let result;
    let message: string = 'Success';
    if (values?.id) {
      result = TaxGroupCRUD.update(values);
      message = 'Update thành công!'
    } else {
      let name = values.name;
      let supplierCode = generateCode(name);
      
      result = TaxGroupCRUD.store({...values, supplier_code: supplierCode, status: 'Đang giao dịch'});
      message = 'Tạo thành công!'
    }
    result.then(res => {
      Toast.fire({
        icon: 'success',
        title: message
      })
      setCreateModal({ ...createModal, show: false })
      setEditModal({ ...editModal, show: false })
      getData({ ...search, page: 1 })

    }).catch(error => {
      const response = error.response
      let message: string = '';
      if (response?.status === 422) {
        if (response?.data?.errors) {
          const arrMess = [];
          for (const [key, mess] of Object.entries(response?.data?.errors)) {
            arrMess.push(mess);
          }
          message = arrMess.join("\n")
        }
      } else {
        message = 'Đã có lỗi xảy ra vui lòng liên hệ Admin'
      }
      Toast.fire({
        icon: 'error',
        title: message
      })
    });
  };

  const handleDelete = async (item: MstTaxGroupModel) => {
    if (item?.inventory_of_sento_count && item?.inventory_of_sento_count > 0) {
      Toast.fire({
        icon: 'error',
        title: 'Nhóm thuế đang được sử dụng, không thể xóa!',
      })  
      return;
    }
    let ids = [item.id];
    Confirm.fire({
      icon: 'question',
      title: intl.formatMessage({ id: 'COMMON.CONFIRM_DELETE' }, { name: 'nhóm thuế đã chọn' }),
      confirmButtonText: intl.formatMessage({ id: 'COMMON.YES' }),
      cancelButtonText: intl.formatMessage({ id: 'COMMON.NO' }),
    }).then(async (res) => {
      if (res.isConfirmed) {
        try {
          const res = await TaxGroupCRUD.remove(ids);
          Toast.fire({
            icon: 'success',
            title: res?.data?.message || intl.formatMessage({ id: 'COMMON.SUCCESS_NOTY' }),
          })
          getData({ ...search, page: 1 })
        } catch (error: any) {
          Toast.fire({
            icon: 'error',
            title: error?.response?.data?.message || intl.formatMessage({ id: 'COMMON.ERROR_NOTY' }),
          })  
        }
      }
    })
  }

  const header: HeaderModel[] = [
    {
        label: 'Tên nhóm',
        style: { minWidth: "150px" },
        field: 'name',
        sortable: true
    },
    {
        label: 'Thuế GTGT(%)',
        style:  {},
        field: 'vat_rate',
        sortable: true
    },
    {
        label: 'Thuế TNCN(%)',
        style:  { minWidth: "100px" },
        field: 'pit_rate',
        sortable: true
    },
    // {
    //     label: 'Thời gian hiệu lực',
    //     style:  { minWidth: "150px" },
    //     field: 'effective_from',
    //     sortable: false
    // }
  ]

  const handleChangeVisCols = (e: any) => {
    let hiddenCols = [...hideCols];
    if (!e.target?.checked) {
        setHideCols([...hiddenCols, e.target.name])
    } else {
        setHideCols(hiddenCols.filter((item) => item !== e.target.name ))
    }
  }
  return (
    <div className="card">
      <div className="card-body">
        <div className="row justify-content-between align-items-center mb-3">
          <div className='col-md-6'>
            <PaginationHeader from={dataPaginate?.meta?.from || 0} to={dataPaginate?.meta?.to || 0}
              total={dataPaginate?.meta?.total || 0} />
          </div>
          <div className='col-md-6 text-end'>
            <Link
              className="btn btn-primary btn-sm"
              to="#"
              onClick={() => {
                setCreateModal({
                  show: true,
                  mode: 'add'
                })
              }}
            ><i className="bi bi-plus fs-4"></i> {intl.formatMessage({ id: 'COMMON.CREATE' })}
            </Link>
          </div>
        </div>

        <TaxGroupTable
          data={dataPaginate?.data || []}
          arrDelete={arrDelete}
          onEdit={handleEdit}
          handleDelete={handleDelete}
          openColConfig={() => setConfigModal({...configModal, show: true})}
          header={header}
          hideCols={hideCols}
          handleSort={handleSort}
        />
      </div>
      <div className="card-footer d-flex justify-content-between paginate-wrapper">
        <PaginationLength selected={search.per_page || DEFAULT_PER_PAGE} onChange={handlePageLengthChange} />
        <Paginate
          pageCount={dataPaginate?.meta?.last_page || 0}
          onPageChange={handlePageChange}
          forcePage={(search.page || 1) - 1}
        />
      </div>
      <TaxGroupCreateModal
        {...createModal}
        onClose={() => { setCreateModal({ ...createModal, show: false }) }}
        onSubmit={handleSubmit}
      />
      <TaxGroupEditModal
        {...editModal}
        onClose={() => { setEditModal({ ...editModal, show: false }) }}
        onSubmit={handleSubmit}
      />
      <ConfigModal
          {...configModal}
          header={header}
          hideCols={hideCols}
          handleChangeVisCols={handleChangeVisCols}
          onClose={() => { setConfigModal({ ...configModal, show: false }) }}
      />
    </div>
  )
}
export default TaxGroup;